module.exports = __webpack_public_path__ + "media/src/img/news-cloud-e3d7554daebda1e51ee2f477a2010fb0.png";